module.exports = __webpack_public_path__ + "488027e4078b51410423c3346458dc37.svg";